import axios from "axios";

export const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d === "object" && typeof d.msg === "string") return d.msg;
  return String(d);
}

export const TOPIC_NAMES = {
  "cardiology": "Cardiology",
  "respiratory": "Respiratory",
  "gastrointestinal": "Gastrointestinal",
  "renal-urology": "Renal & Urology",
  "infection": "Infection",
  "ent": "ENT",
  "ophthalmology": "Ophthalmology",
  "dermatology": "Dermatology",
  "haematology": "Haematology",
  "obstetrics-gynaecology": "Obstetrics & Gynaecology",
  "child-adolescent-health": "Child & Adolescent Health",
  "neuroscience": "Neuroscience",
  "mental-health": "Mental Health",
  "musculoskeletal-orthopaedics": "Musculoskeletal & Orthopaedics",
};

export function fmtDate(d) {
  if (!d) return "—";
  return new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

export function fmtTime(ms) {
  if (!ms && ms !== 0) return "—";
  const s = Math.round(ms / 1000);
  if (s < 60) return `${s}s`;
  return `${Math.floor(s / 60)}m ${s % 60}s`;
}
